import React from 'react';
import { Plugin } from '@devexpress/dx-react-core';
import { PagingState, CustomPaging } from '@devexpress/dx-react-grid';
import { PagingPanel } from '@devexpress/dx-react-grid-material-ui';
import { DefaultTablePagination } from '../table-components/DefaultTablePagination';
import { TableStateContext } from '../TableStateContext';
import { useOptimisticPage } from '../hooks/useOptimisticPage';

export const RemotePagingPlugin = ({ ...props }) => {
  // @ts-expect-error TS(2339): Property 'state' does not exist on type 'unknown'.
  const { state, handlers, ...rest } = React.useContext(TableStateContext);
  return (
    <RemotePagingPluginBase {...props} {...state} {...handlers} {...rest} />
  );
};

const RemotePagingPluginBase = ({
  root = DefaultTablePagination,
  meta = {},
  ...props
}: any) => {
  const { nextToken, prevToken } = meta;
  const propsPage = Number(props.page ?? 0);

  const { page, changePage } = useOptimisticPage(propsPage);

  return (
    <Plugin>
      <PagingState
        currentPage={page}
        onCurrentPageChange={(newPage) =>
          changePage(newPage, (next) =>
            props.onCurrentPageChange(next, nextToken, prevToken)
          )
        }
        onPageSizeChange={props.onPageSizeChange}
        pageSize={Number(props.size)}
      />
      <CustomPaging totalCount={meta.total || props.totalCount} />
      <PagingPanel pageSizes={props.pageSizes} containerComponent={root} />
    </Plugin>
  );
};

export default RemotePagingPluginBase;
